export default "__VITE_ASSET__BWMU8WRa__"